// extracted by mini-css-extract-plugin
module.exports = {"container":"i_E1","body":"i_E2","section":"i_E3","meta":"i_E4","meta-list":"i_E5","meta-item":"i_E6","intro":"i_E7","footer-legal":"i_E8","image":"i_E9"};